import React from 'react';

export const InsightsNoData = () => (
  <div className="CampaignInsights-nodata">
    <span className="CampaignInsights-nodata-text">No data in the selected period</span>
  </div>
);
